import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { useParams } from 'react-router-dom';
import EmoteForm from './EmoteForm';
// import { initialValues  } from './initialValues-testing';
import { showEmoteApi, updateEmoteApi, clearEditedEmote } from './emoteSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { pictureAttributeNames } from './initialValue';
import uploadImage from '~/api/uploadImage';

function EmoteUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues } = useSelector((state) => state.itemSaga.emote);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (values) => {
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        await uploadImage(values, pictureAttributeNames, 'emotes');
        dispatch(updateEmoteApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showEmoteApi({ navigate, id }));

        return () => dispatch(clearEditedEmote());
    }, []);

    return (
        <EmoteForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default EmoteUpdate;
